export default function(n: number|string|undefined|null, dp = 0) {
    if (n === undefined || n === null || n === '') {
        n = 0;
    }

    if (typeof n === 'string') {
        const parsed = parseFloat(n);
        n = Number.isNaN(parsed) ? 0 : parsed;
    }
    const numberString = n.toFixed(dp);

    if (Math.abs(n) < 9999) {
        return numberString;
    }

    const parts = numberString.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return parts.join('.');
}
